(() => {
  const root = document.querySelector('[data-product-root]');
  if (root) {
    const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
    const selects = [...root.querySelectorAll('[data-product-option]')];
    const idField = root.querySelector('[data-variant-id]');
    idField.name = 'id';
    const add = root.querySelector('[data-add-to-bag]');
    const status = root.querySelector('[data-product-status]');
    const main = root.querySelector('#product-main-image');
    const setImage = src => { if (!src || !main) return; main.src = src; main.removeAttribute('srcset'); };
    const update = () => {
      const values = selects.map(s => s.value);
      const variant = variants.find(v => v.options.every((o,i) => o === values[i]));
      idField.value = variant ? variant.id : '';
      add.disabled = !variant || !variant.available;
      add.textContent = !values.every(Boolean) ? 'Select Your Options' : !variant || !variant.available ? 'Currently Unavailable' : 'Add to Cart';
      status.textContent = values.every(Boolean) && (!variant || !variant.available) ? 'This selection is currently unavailable. Please choose another option.' : '';
      if (variant) {root.querySelector('[data-product-price]').textContent = variant.price; setImage(variant.image);}
    };
    selects.forEach(s => s.addEventListener('change',update));
    root.querySelectorAll('[data-image-src]').forEach(button => button.addEventListener('click',() => {
      setImage(button.dataset.imageSrc);
      root.querySelectorAll('[data-image-src]').forEach(b => {b.classList.toggle('is-active',b === button); b.setAttribute('aria-pressed', String(b === button));});
    }));
    const queryVariant = new URLSearchParams(location.search).get('variant');
    const chosen = variants.find(v => String(v.id) === queryVariant);
    if (chosen && selects.length) { selects.forEach((s,i) => s.value = chosen.options[i]); update(); }
    if (selects.length) update();
    root.setAttribute('data-ready','true');
    const form = root.querySelector('.product-form');
    form.addEventListener('submit',async event => {
      if (!window.fetch) return;
      event.preventDefault();
      if (!idField.value || !form.reportValidity()) return;
      add.disabled = true; add.textContent = 'Adding…'; status.textContent = '';
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'We could not add this piece. Please try again.');
        location.assign(base + 'cart');
      } catch(error) { status.textContent = error.message; add.disabled = false; add.textContent = 'Add to Cart'; }
    });
    root.querySelector('[data-image-zoom]')?.addEventListener('click',() => {
      const dialog = document.querySelector('#image-dialog');
      const enlarged = dialog.querySelector('img'); enlarged.src = main.currentSrc || main.src; enlarged.alt = main.alt;
      dialog.showModal();
    });
  }
  const dialog = document.querySelector('#image-dialog');
  document.querySelector('[data-close-image]')?.addEventListener('click',() => dialog.close());
  dialog?.addEventListener('click',event => { if (event.target === dialog) dialog.close(); });
  const menu = document.querySelector('.mobile-menu');
  const menuToggle = menu?.querySelector('summary');
  const setMenu = open => { menu.open = open; menuToggle.setAttribute('aria-expanded',String(open)); };
  menuToggle?.setAttribute('aria-expanded',String(menu.open));
  menuToggle?.addEventListener('click',event => { event.preventDefault(); setMenu(!menu.open); });
  document.addEventListener('keydown',event => { if (event.key === 'Escape' && menu) setMenu(false); });
})();

